import on from 'dom-event';
import debounce from 'lodash/debounce';
import { isTablet } from 'utils/general';

export default {
  props: {
    mobileId: String,
    desktopId: String,
    autoPlay: {
      type: String,
      default: "enable"
    },
  },
  data: () => ({
    isTablet: isTablet(),
    isPaused: false,
    isMuted: true,
    video: null
  }),
  mounted () {
    on(window, 'resize', debounce(this.onResize, 300));
    this.initializeVideo();
    this.isPaused = this.autoPlay === 'disable';
  },
  watch: {
    iFrameSrc() {
      this.initializeVideo();
    },
  },
  computed: {
    iFrameSrc() {
      if (this.isTablet) {
        if (this.mobileId) {
          return `https://player.vimeo.com/video/${this.mobileId}?background=1&autoplay=${this.autoPlay == "enable" ? 1 : 0}`;
        }
      } else {
        if (this.desktopId) {
          return `https://player.vimeo.com/video/${this.desktopId}?background=1&autoplay=${this.autoPlay == "enable" ? 1 : 0}`;
        }
      }
      return '';
    },
  },
  methods: {
    initializeVideo() {
      if (this.$refs?.iFrameEl && typeof Vimeo !== 'undefined' && Vimeo.Player) {
        try {
          this.video = new Vimeo.Player(this.$refs.iFrameEl);
        } catch (error) {
          console.warn('Failed to initialize Vimeo player:', error);
        }
      } else if (this.$refs?.iFrameEl && typeof Vimeo === 'undefined') {
        this.waitForVimeo();
      }
    },
    waitForVimeo() {
      const checkVimeo = () => {
        if (typeof Vimeo !== 'undefined' && Vimeo.Player) {
          this.initializeVideo();
        } else {
          setTimeout(checkVimeo, 100);
        }
      };
      checkVimeo();
    },
    onResize() {
      this.isTablet = isTablet();
    },
    handlePauseClick() {
      if (this.video) {
        this.isPaused ? this.video.play() : this.video.pause();
        this.isPaused = !this.isPaused;
      }
    },
    handleSoundClick() {
      if (this.video) {
        this.isMuted = !this.isMuted;
        this.video.setMuted(this.isMuted);
      }
    },
  },
};
